import $ from 'jquery';
import * as breakpoint from '@pixelunion/breakpoint';
import EventHandler from '@pixelunion/events';

import Parallax from '../components/Parallax';

function findSlide(slides, el) {
  if (el instanceof $) {
    for (let i = 0; i < slides.length; i++) {
      const slide = slides[i];

      if (slide.$el.is(el)) {
        return slide;
      }
    }
  } else {
    for (let i = 0; i < slides.length; i++) {
      const slide = slides[i];

      if (slide.el === el) {
        return slide;
      }
    }
  }

  return null;
}

export default class DynamicSlideshow {
  constructor(section) {
    this.el = section.el;
    this.settings = section.data;

    this.transition = this.settings.transition;
    this.parallax = this.settings.parallax;
    this.fixedHeightMobile = this.settings.fixedHeightMobile;
    this.fixedHeightDesktop = this.settings.fixedHeightDesktop;
    this.nextSlide = this.nextSlide.bind(this);
    this.previousSlide = this.previousSlide.bind(this);
    this.jumpToSlide = this.jumpToSlide.bind(this);
    this._heightIsNotFixed = this._heightIsNotFixed.bind(this);
    this.slides = [];
    this.events = new EventHandler();

    this.el.querySelectorAll('.slide').forEach(slide => {
      const currentSlide = {
        el: slide,
        $el: $(slide),
        img: slide.querySelector('img, svg'),
        imgWrap: slide.querySelector('.image-wrap'),
        getImageHeight: () => {
          const scaleRegex = /scale\(([1-9]+\.[0-9]+)\)/g;
          const img = slide.querySelector('img, svg');
          const imgScale = scaleRegex.exec(img.style.transform);
          return imgScale && imgScale.length === 2
            ? img.getBoundingClientRect().height / parseFloat(imgScale[1])
            : img.getBoundingClientRect().height;
        },
        parallax: this.parallax
        ? new Parallax({
          img: slide.querySelector('img, svg'),
          container: slide.querySelector('.image-wrap'),
          isVisible: () => slide.classList.contains('active'),
        })
        : null,
      }
      this.slides.push(currentSlide);
    });

    this.slideshow = $('.slideshow', this.el);
    this.slideshowViewport = $('[data-slideshow-viewport]', this.el);
    this.$imageWraps = $('.slide .image-wrap', this.el);
    this.jumpLinksWrap = $('.jump-to-slide', this.el);
    this.fadeSpeed = 200;
    this.autoPlay = parseInt($('.slideshow', this.el).attr('data-autoplay'), 10);

    this._setFirstSlideHeight = this._setFirstSlideHeight.bind(this);
    // Setup the slides and jump pagination
    const firstSlide = this.slides[0];

    if (!firstSlide) return;

    const firstImage = firstSlide.el.querySelector('img');
    if (!firstImage || firstImage.naturalHeight > 0) {
      this._setFirstSlideHeight();
    } else {
      this.events.register(firstImage, 'load', this._setFirstSlideHeight);
    }

    this.jumpLinks = this.jumpLinksWrap.find('li');
    this.jumpLinksWrap.find('li:first').addClass('active');

    // Add context to section following slideshow
    if (this.slideshow.attr('data-full-width') === 'true') {
      this.slideshow.parents('.shopify-section').next('.shopify-section:not(.shopify-section--image-with-text)').addClass('slideshow-sibling-section');
    }

    // Remove pagination when only one slide is present
    if (this.slides.length === 1) {
      $('.next, .prev, .jump-to-slide', this.el).remove();
    }

    // Setup autoplay / auto-rotation of slideshow
    if (this.autoPlay > 1 && this.slides.length > 1) {
      this.autoPlaySlides();

      this.viewportCheckInterval = setInterval(() => {
        if (!this.isInViewport(this.el.querySelector('.slideshow')) && this.interval) {
          clearInterval(this.interval);
          this.interval = null;
        } else if (this.isInViewport(this.el.querySelector('.slideshow')) && !this.interval) {
          this.interval = setInterval(
            () => {
              if (!$('.slideshow', this.el).hasClass('paused')) {
                this.nextSlide();
              }
            },
            this.autoPlay,
          );
        }
      });
    }

    // Set height of active slide on window resize
    $(window).on('resize', () => {
      const isNotFixed = this._heightIsNotFixed();
      const activeSlide = this.slides.reduce((currentSlide, slide) => {
        if (slide.el.classList.contains('active')) {
          return slide;
        }

        return currentSlide;
      }, null);

      activeSlide.imgWrap.style.height = '';

      const imgHeight = activeSlide.getImageHeight();

      if (isNotFixed) {
        this.$imageWraps.css({
          height: imgHeight,
        });
      } else {
        this.$imageWraps.css({
          height: '',
        });
      }

      this.positionButtons();
    });

    if (this.slides.length > 0) {
      this.slides.forEach(() => this.jumpLinksWrap.append($('<li>')));
    }

    this.jumpLinksWrap[0].querySelector('li').classList.add('active');

    $('.next', this.el).on('click', this.nextSlide);
    $('.prev', this.el).on('click', this.previousSlide);
    $('.jump-to-slide li', this.el).on('click', this.jumpToSlide);
  }

  _setFirstSlideHeight() {
    const firstSlide = this.slides[0];
    const $firstSlideEl = firstSlide.$el;
    const lastSlide = this.slides[this.slides.length - 1];
    const $lastSlideEl = lastSlide.$el;

    $firstSlideEl.addClass('first');
    $lastSlideEl.addClass('last');

    this.slideshow.addClass('slideshow--loaded');
    $firstSlideEl.css('z-index', 2000).addClass('active');

    firstSlide.imgWrap.style.height = '';
    const isNotFixed = this._heightIsNotFixed();
    const imgHeight = firstSlide.getImageHeight();

    if (isNotFixed) {
      this.$imageWraps.css({
        height: imgHeight,
      });
    } else {
      this.$imageWraps.css({
        height: '',
      });
    }
    this.positionButtons();
  }

  selectedHeight(el) {
    clearTimeout(this.timeout);

    $(el).on('rimg:load', () => {
      this.timeout = setTimeout(
        () => {
          const slide = findSlide(this.slides, this.el.querySelector('.slide'));

          $(el).addClass('active');

          slide.imgWrap.style.height = '';

          const isNotFixed = this._heightIsNotFixed();
          const imgHeight = slide.getImageHeight();

          if (isNotFixed) {
            this.$imageWraps.css({
              height: imgHeight,
            });
          } else {
            this.$imageWraps.css({
              height: '',
            });
          }
        },
        1000,
      );
    });
  }

  autoPlaySlides() {
    if ($('.slideshow', this.el).hasClass('autoplay-enabled')) { return; }

    if (this.slides.length > 1) {
      $('.slideshow', this.el).addClass('autoplay-enabled');

      this.interval = setInterval(
        () => {
          if (!$('.slideshow', this.el).hasClass('paused')) {
            this.nextSlide();
          }
        },
        this.autoPlay,
      );
    }
  }

  slideStatus() {
    $('.slideshow', this.el).toggleClass('paused');
  }

  lockSlide(event) {
    this.slidesLocked = true;
    $('.slideshow', this.el).addClass('paused');
    this.jumpToSlide(event);
    this.selectedHeight(event.target);
  }

  unlockSlide() {
    this.slidesLocked = false;
    $('.slideshow', this.el).removeClass('paused');
  }

  nextSlide() {
    const isLast = $('.slide.active', this.el).hasClass('last');
    const upcomingSlide = isLast
      ? this.slides[0]
      : findSlide(this.slides, $('.slide.active', this.el).next());
    this.switchToSlide(upcomingSlide);
  }

  previousSlide(e) {
    const isFirst = $('.slide.active', this.el).hasClass('first');
    const upcomingSlide = isFirst
      ? this.slides[this.slides.length - 1]
      : findSlide(this.slides, $('.slide.active', this.el).prev());
    this.switchToSlide(upcomingSlide);
  }

  jumpToSlide(event) {
    const jumpPosition = $(event.target).index();
    const upcomingSlide = this.slides[jumpPosition];
    this.switchToSlide(upcomingSlide);
  }

  switchToSlide(upcomingSlide) {
    const currentSlide = findSlide(this.slides, this.el.querySelector('.slide.active'));
    const upcomingSlidePosition = upcomingSlide.$el.index();

    // Update jumpLinks
    for (let i = 0; i < this.jumpLinksWrap.length; i++) {
      const jumpLinksWrap = $(this.jumpLinksWrap[i]);
      const jumpLinks = jumpLinksWrap.find('li');
      const upcomingJumpLink = jumpLinks.eq(upcomingSlidePosition);
      const currentJumpLink = jumpLinks.filter('.active');

      currentJumpLink.removeClass('active');
      upcomingJumpLink.addClass('active');
    }

    // Adjust slideshow height
    upcomingSlide.imgWrap.style.height = '';
    upcomingSlide.el.style.display = 'block';

    const isNotFixed = this._heightIsNotFixed();
    const imgHeight = upcomingSlide.getImageHeight();

    if (isNotFixed) {
      this.$imageWraps.css({
        height: imgHeight,
      });
    } else {
      this.$imageWraps.css({
        height: '',
      });
    }

    // Fire away!
    if (this.transition === 'slide') {
      currentSlide.$el.removeClass('active');
      upcomingSlide.$el.addClass('active');
      upcomingSlide.el.style.display = '';

      this.positionButtons();

      this.slideshowViewport.attr('class', 'slideshow--viewport');
      this.slideshowViewport.addClass(`slideshow--position-${upcomingSlide.$el.index()}`);
    } else {
      currentSlide.$el.fadeTo(this.fadeSpeed, 0, () => currentSlide.$el.removeClass('active'));

      upcomingSlide.$el.fadeTo(this.fadeSpeed, 1, () => {
        upcomingSlide.$el.addClass('active');
        upcomingSlide.el.style.display = '';
        this.positionButtons();
      });
    }
  }

  positionButtons() {
    const contentHeight = $('.slide.active .image-wrap', this.el).height();
    $('.jump-to-slide', this.el).css('margin-top', contentHeight);
    $('.next, .prev', this.el).css('transform', `translateY(${(parseInt(contentHeight, 10) / 2) - 30}px)`);
  }

  isInViewport(el) {
    const root = document.documentElement;
    const width = Math.min(root.clientWidth, window.innerWidth);
    const height = Math.min(root.clientHeight, window.innerHeight);
    const rect = el.getBoundingClientRect();

    return (
      rect.bottom >= 0 &&
      rect.right >= 0 &&
      rect.top <= height &&
      rect.left <= width
    );
  }

  onSectionBlockSelect(data) {
    const event = {
      target: data.el,
      $el: $(data.el)
    };

    if (this.transition === 'slide') {
      $('.slide', this.el).removeClass('active');
      $(data.el).addClass('active');
    }

    $('.slideshow--viewport').css('transition', '0s');

    this.lockSlide(event);

    setTimeout(() => {
      $('.slideshow--viewport').css('transition', '');
    }, 300);
  }

  onSectionBlockDeselect() {
    this.unlockSlide();
  }

  onSectionUnload() {
    this.$imageWraps.css({
      height: '',
    });

    clearTimeout(this.timeout);
    clearInterval(this.interval);
    $('.next', this.el).off('click');
    $('.prev', this.el).off('click');
    $('.jump-to-slide li', this.el).off('click');
    this.events.unregisterAll();
  }

  _heightIsNotFixed() {
    return (breakpoint.is('S') && !this.fixedHeightMobile) ||
      (breakpoint.is('M','L') && !this.fixedHeightDesktop);
  }
}
